module.exports = __webpack_public_path__ + "img/neifenmi.19edf3cd.png";